import React from 'react';
import AUIIcon from '@ancert/aui-icon';
import AUIButton from '@ancert/aui-button';
import { useFormularDenuncia } from '../../context/formularDenuncia.context';

const DenunciaCorrecta = () => {
  const { result: data, goHome } = useFormularDenuncia();

  return (
    <section className="c-sii-denuncia-correcta">
      <header className="c-sii-denuncia-correcta__header">
        <AUIIcon icon="okCircleOutline" color="green" size="xxl" />
        <h1 className="c-sii-denuncia-correcta__tit">La comunicación ha sido enviada correctamente</h1>
      </header>
      {data?.user && data?.password ? (
        <div className="c-sii-denuncia-correcta__info u-mt-40">
          <ul className="c-sii-denuncia-correcta__list">
            <li className="c-sii-denuncia-correcta__item">
              <AUIIcon icon="user" color="blue" size="md" />
              <b>Usuario: {data?.user}</b>
            </li>
            <li className="c-sii-denuncia-correcta__item">
              <AUIIcon icon="key" color="blue" size="md" />
              <b>Contraseña: {data?.password}</b>
            </li>
          </ul>
          <p className="u-mt-32">
            Por favor, guarde su usuario y contraseña para poder acceder a la comunicación más tarde.
          </p>
          <p className="u-mt-24">
            <strong>IMPRESCINDIBLE: </strong> No pierda esta información puesto que no volverá a mostrarse en pantalla.
          </p>
        </div>
      ) : (
        <p className="u-mt-40 c-sii-denuncia-correcta__txt">
          Recibirá sus datos de acceso, junto al comprobate de depósito de su denuncia, en la dirección de correo
          electrónico que nos ha facilitado.
        </p>
      )}
      <footer className="c-sii-denuncia-correcta__buttons u-mt-40">
        <AUIButton label="Volver a inicio" size="lg" onClick={goHome} />
      </footer>
    </section>
  );
};
DenunciaCorrecta.propTypes = {};
DenunciaCorrecta.defaultProps = {};

export default DenunciaCorrecta;
